import { lineHasCatalogHandset } from './handsetLine';

export interface ContractListHandsetSummaryItem {
  nome: string;
  quantidade: number;
  valorMensal: number;
  valorTotal: number;
}

export function formatCurrencyBrl(value: number): string {
  return `R$ ${value.toFixed(2).replace('.', ',')}`;
}

export function mergeHandsetSummaries(
  items: ContractListHandsetSummaryItem[]
): ContractListHandsetSummaryItem[] {
  const map = new Map<string, ContractListHandsetSummaryItem>();
  for (const item of items) {
    const key = `${item.nome}|${item.valorMensal}`;
    const existing = map.get(key);
    if (existing) {
      existing.quantidade += item.quantidade;
      existing.valorTotal += item.valorTotal;
    } else {
      map.set(key, { ...item });
    }
  }
  return Array.from(map.values()).sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR'));
}

export function formatHandsetSummaryPopupText(items: ContractListHandsetSummaryItem[]): string {
  if (!items.length) return 'Nenhum aparelho de catálogo neste contrato.';
  return items
    .map((item) => {
      const qtd = item.quantidade > 1 ? ` (${item.quantidade}x)` : '';
      return `${item.nome}${qtd}\nParcela: ${formatCurrencyBrl(item.valorMensal)} · Total: ${formatCurrencyBrl(item.valorTotal)}`;
    })
    .join('\n\n');
}

export function formatLineAparelhoLabel(line: {
  aparelho?: string | null;
  handsetDeviceId?: string | null;
  tipoVenda?: string | null;
  aparelhoValorMensal?: number | null;
  aparelhoValorTotal?: number | null;
}): { title: string; detail?: string } {
  if (!lineHasCatalogHandset(line)) {
    return { title: '—' };
  }
  const title = (line.aparelho ?? '').trim() || 'Aparelho';
  const mensal = line.aparelhoValorMensal ?? 0;
  const total = line.aparelhoValorTotal ?? (mensal > 0 ? mensal * 24 : 0);
  const parts: string[] = [];
  if (total > 0) parts.push(`Total ${formatCurrencyBrl(total)}`);
  if (mensal > 0) parts.push(`24x ${formatCurrencyBrl(mensal)}`);
  return { title, detail: parts.length ? parts.join(' · ') : undefined };
}
